
import { SaleRow } from "@/models/base";
import { PurchaseDocumentRowService, SaleRowService, SaleRowServiceClass } from "@/services/sale-row-service";
import Vue from "vue";
import AppSaleTypeSelect from "@/components/sales/SaleTypeSelect.vue";

export default Vue.extend({
	data(){
		return {
			targetTypeId: 5
		};
	},
	props: {
		rows: {
			type: Array as ()=>SaleRow[],
			default: ()=>[]
		},
		contactGroupId: Number
	},
	computed: {
		service():SaleRowServiceClass{
			if (this.contactGroupId == 2) {
				return PurchaseDocumentRowService;
			}
			return SaleRowService;
		}
	},
	watch: {
		isPurchaseType: {
			immediate: true,
			handler(){
				if (this.contactGroupId == 2) {
					this.targetTypeId = 13;
				}else{
					this.targetTypeId = 5;
				}
			}
		}
	},
	methods: {
		async confirm(){
			let rowIds:number[] = [];
			if (this.rows.length != 0) {
				rowIds = this.rows.filter(r=>r.LastDelivered > 0).map(r=>r.ID);
			}
			let toCreateCount = rowIds.length;
			if (toCreateCount == 0 && this.rows.length == 0) {
				toCreateCount = await this.service.afleveringsbonnenOfDeliveredGoodsCount();
			}
			if (toCreateCount == 0) {
				this.$wf.notify(this.$ct("no-automatic-afleveringsbonnen-to-create"), "info", 3000, "info");
				return;
			}
			let confirmText = this.$ctc("are-you-sure-you-want-to-create-afleveringsbonnen-for-x-rows", toCreateCount, {count: toCreateCount});
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(confirmText).show();
			if (!confirm) return;
			await this.service.createAfleveringsbonnenOfDeliveredGoods(rowIds, this.targetTypeId);
			this.$wf.notify(this.$ct("afleveringsbonnen-are-being-created"), "success", 3000, "check");
			this.close();
		},
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppSaleTypeSelect
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
